import React from "react";
import avatars from "../assets/images/users/avatars.jpg";
import { Link, useNavigate } from "react-router-dom";
import { getImageSrc, useVariantImageUrlMap } from "components/Tableimageshelpers";
import { User, CircleHelp, LogOut } from "lucide-react";
import NotificationDropdown from "./Notifications/NotificationDropdown";
import { performLogout } from "../api/authApi";

type ProfileDropdownnProps = {
  name: string;
  role: string;
  imageUrl: string;
  login: string;
  token: string;
};

const ProfileDropdownn = ({ name, role, imageUrl, login, token }: ProfileDropdownnProps) => {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await performLogout(token);
    navigate("/", { replace: true });
    window.location.reload();
  };

  const dataForMap = React.useMemo(() => {
    const id = imageUrl;
    return id ? [{ product: { variants: [{ images: [{ url: id }] }] } }] : [];
  }, [imageUrl]);
  // Get the presigned URL map
  const imageUrlMap = useVariantImageUrlMap(dataForMap, token || null);

  // Resolve final avatar URL from id (or fall back if needed)
  const avatarUrl: string | undefined =
    getImageSrc(imageUrl, imageUrlMap) ||
    (typeof imageUrl === "string" && imageUrl.startsWith("http")
      ? imageUrl
      : undefined);

  // Cleanly join base + path (no double slashes, works with/without trailing slash)
  const root = (process.env.REACT_APP_BASE_URL || "").replace(/\/+$/, "");
  const pathone = `/${String(login || "").trim()}`.replace(/\/{2,}/g, "/");
  const baseUrlone = `${root}${pathone}/profile`;
  return (
    <>
      <NotificationDropdown login={login} />

      <div className="dropdown ms-sm-3 header-item topbar-user profile-dropdown">
        <button
          type="button"
          className="btn material-shadow-none profile-trigger"
          id="page-header-user-dropdown"
          data-bs-toggle="dropdown"
          aria-haspopup="true"
          aria-expanded="false"
          onClick={(event) => event.preventDefault()}
        >
          <span className="d-flex align-items-center">
            <span className="profile-avata1r1 me-2">
              {avatarUrl ? (
                <img
                  src={avatarUrl}
                  alt={name}
                  className="avatar-img rounded-circle shadow"
                  onError={(e) => ((e.currentTarget.style.display = "none"))}
                  style={{ width: 40, height: 40, objectFit: "cover" }}
                />
              ) : (
                <div className="avatar-initials-header rounded-circle shadow d-flex align-items-center justify-content-center">
                  {name?.trim().split(/\s+/).map(w => w.charAt(0).toUpperCase()).join("").slice(0, 2)}
                </div>
              )}
            </span>
            <span className="text-start ms-xl-2">
              <span className="d-none d-xl-inline-block ms-1 fw-medium user-name-text">
                {name}
              </span>
              <span className="d-none d-xl-block ms-1 fs-12 user-name-sub-text">
                {role.replace("_", " ")}
              </span>
            </span>
            <span className="user-name-caret ms-1 fs-20">
              <i className="ri-arrow-down-s-line text-black"></i>
            </span>
          </span>
        </button>
        <div className="dropdown-menu dropdown-menu-end profile-dropdown-menu show-me">
          <h6 className="dropdown-header">Welcome {name}</h6>

          {/* Profile */}
          <Link className="dropdown-item profile-new-item" to={baseUrlone}>
            <User size={18} className="text-muted" />
            <span className="align-middle fs-14">Profile</span>
          </Link>

          {/* Help & Support */}
          <Link className="dropdown-item profile-new-item" to={`/${login}/help`}>
            <CircleHelp size={18} className="text-muted" />
            <span className="align-middle fs-14">Help & Support</span>
          </Link>

          {/* Logout */}
          <div className="dropdown-item profile-new-item logout-row">
            <LogOut size={18} className="text-muted" />
            <Link
              to=""
              onClick={handleLogout}
              className="d-flex gap-2 fs-14 fw-bold logcolor"
            >
              <i className="ri-logout-box-line"></i>{" "}
              <span data-key="t-dashboards">Logout</span>
            </Link>
          </div>
        </div>

        {/* <div className="dropdown-menu dropdown-menu-end profile-dropdown-menu">
        <h6 className="dropdown-header">Welcome {name}</h6>
        <Link className="dropdown-item profile-item" to={baseUrlone}>
          <span className="profile-avatar1 me-2">
            {avatarUrl ? (
              <img
                src={avatarUrl}
                alt={name}
                className="avatar-img rounded-circle shadow"
                onError={(e) => ((e.currentTarget.style.display = "none"))}
                style={{ width: 32, height: 32, objectFit: "cover" }}
              />
            ) : (
              <div className="avatar-initials-header rounded-circle shadow d-flex align-items-center justify-content-center">
                {name?.trim().split(/\s+/).map(w => w.charAt(0).toUpperCase()).join("").slice(0, 2)}
              </div>
            )}
          </span>
          <span className="align-middle fs-14 fw-bold">Profile</span>
        </Link>
        <div className="dropdown-item logout-item">
          <LogoutButton />
        </div>
      </div> */}
        <style>{`
  .profile-avatar1 {
    width: 40px; height: 40px; flex: 0 0 40px;
    display: inline-block; position: relative;
  }
  .profile-avatar1 .avatar-img,
  .profile-avatar1 .avatar-initials-header {
    width: 40px; height: 40px; border-radius: 50%;
  }
  .profile-avatar1 .avatar-img { object-fit: cover; }
  .profile-avatar1 .avatar-initials-header {
    background: linear-gradient(135deg, #5b8dff, #7b3fff);
    color: #fff;
    font-weight: 700; font-size: 14px; line-height: 1;
  }
  .avatar-initials-header {
    width: 40px;
    height: 40px;
    background: linear-gradient(135deg, #5b8dff, #7b3fff);
    color: #fff;
    font-weight: 700;
    font-size: 14px;
    line-height: 1;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-top: 3px;
  }
  .profile-dropdown .profile-trigger {
    display: flex;
    align-items: center;
    gap: .35rem;
    color: #d4daef;
  }
  .profile-dropdown .user-name-caret {
    display: inline-flex;
    align-items: center;
    transition: transform .2s ease;
    color: inherit;
  }
  .profile-dropdown .profile-trigger[aria-expanded="true"] .user-name-caret {
    transform: rotate(180deg);
  }

  /* Bootstrap kills left border with overflow hidden */
  .profile-dropdown-menu {
    overflow: visible !important; 
    background: #ffffff;
    border-radius: 12px;
    padding: 0.75rem 0;
    min-width: 240px;
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
    border: 1px solid #f0f0f0;
    transform-origin: top center;
    transform: translateY(-12px) scaleY(.92);
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    display: block;
    max-height: 0;
    transition: transform .25s ease, opacity .25s ease, max-height .25s ease, visibility .25s ease;
  }
  
  .profile-dropdown-menu.show {
    transform: translateY(0) scaleY(1);
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
    max-height: 480px;
  }

  /* Section title */
  .profile-dropdown-menu .dropdown-header {
    padding: 0.5rem 1.25rem;
    font-size: 13px;
    color: #6b7280;
    text-transform: none;
    margin-bottom: 0.25rem;
  }

  /* Profile new item - base styles (NO BORDER by default) */
  .profile-dropdown-menu .profile-new-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0.6rem 1.25rem;
    margin: 0 0.5rem 0.35rem;
    margin-left: 0.5rem;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #1f2937 !important;
    border-left: 0px solid transparent;
    transition: background-color 0.22s ease, border-left 0.22s ease, color 0.22s ease;
    text-decoration: none;
    background: transparent;
  }

  .profile-dropdown-menu .profile-new-item:last-child {
    margin-bottom: 0;
  }

  /* Icon normal state */
  .profile-dropdown-menu .profile-new-item svg {
    color: #6b7280;
    transition: color 0.22s ease;
  }

  /* Hover state for profile items - BORDER SHOWS ONLY ON HOVER */
  .profile-dropdown-menu .profile-new-item:hover {
    background: #f3f4f6 !important;
    border-left: 3px solid #155dfc !important;
    color: #111827 !important;
    margin-left: 0.5rem;
  }

  .profile-dropdown-menu .profile-new-item:hover svg {
    color: #155dfc !important;
  }

  /* Logout row specific styles (NO BORDER by default) */
  .profile-dropdown-menu .logout-row {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0.6rem 1.25rem;
    margin: 0 0.5rem 0.35rem;
    margin-left: 0.5rem;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 500;
    color: #1f2937 !important;
    border-left: 0px solid transparent;
    transition: background-color 0.22s ease, border-left 0.22s ease, color 0.22s ease;
    cursor: pointer;
    background: transparent;
  }

  .profile-dropdown-menu .logout-row svg {
    color: #6b7280;
    transition: color 0.22s ease;
  }

  .profile-dropdown-menu .logout-row button {
    background: transparent !important;
    border: none !important;
    font-size: 14px !important;
    color: #dc2626 !important;
    padding: 0;
    margin: 0;
    font-weight: 500;
    cursor: pointer;
  }

  /* Logout hover state - BORDER SHOWS ONLY ON HOVER */
  .profile-dropdown-menu .logout-row:hover {
    background: #fef2f2 !important;
    border-left: 3px solid #dc2626 !important;
    margin-left: 0.5rem;
  }

  .profile-dropdown-menu .logout-row:hover svg {
    color: #dc2626 !important;
  }

  @media (max-width: 991px) {
    .profile-dropdown-menu {
      min-width: 0;
      max-width: 60vw;
      right: 0;
      left: auto;
    }
  }
  
  @media (max-width: 575px) {
    .profile-dropdown-menu {
      width: 60vw;
    }
  }
`}</style>

      </div>
    </>
  );
};

export default ProfileDropdownn;

























